const options = {
  5: "bg-violet-200/5",
  10: "bg-violet-200/10",
  25: "bg-violet-200/25",
  50: "bg-violet-200/50",
  75: "bg-violet-200/75",
  90: "bg-violet-200/90",
  100: "bg-violet-200",
};

const from = {
  5: "from-violet-200/5",
  10: "from-violet-200/10",
  25: "from-violet-200/25",
  50: "from-violet-200/50",
  75: "from-violet-200/75",
  90: "from-violet-200/90",
  100: "from-violet-200",
};

export default function getBackgroundViolet200(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
